import React from 'react'
import PropTypes from 'prop-types'
import { facebookButton } from 'theme/default'
import Component from 'decorators/Component'
import IconFacebook from 'components/Icons/IconFacebook'
import { StyledButton } from './Elements'

export const FacebookButton = ({ t, onClick, fetching }) => (
  <StyledButton
    {...facebookButton}
    loading={fetching}
    onClick={onClick}
    Icon={IconFacebook}
  >
    {t('Continue with Facebook')}
  </StyledButton>
)
FacebookButton.propTypes = {
  onClick: PropTypes.func,
  fetching: PropTypes.bool
}

export default Component()(FacebookButton)
